var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 277.937,
    cy: 346,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.937,471.999h-249c-22.056,0-40-17.944-40-40v-164c0-22.056,17.944-40,40-40h288c4.554,0,8.167,0.402,11.047,1.227 c10.618,3.042,21.692-3.1,24.735-13.718c3.042-10.618-3.1-21.692-13.718-24.735c-6.513-1.866-13.73-2.773-22.064-2.773H359.9 v-70.534C359.9,52.695,306.068,0,239.9,0s-120,52.695-120,117.466V188H95.937c-44.112,0-80,35.888-80,80v164 c0,44.112,35.888,80,80,80h249c11.046,0,20-8.954,20-20C364.937,480.954,355.983,472,344.937,471.999z M159.9,117.466 c0-42.715,35.888-77.466,80-77.466s80,34.751,80,77.466V188h-160V117.466z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.937,
    cy: 346,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.046,331.21c-0.438-38.789-32.13-70.21-71.021-70.21C385.863,261,354,292.862,354,332.025c0,11.046,8.954,20,20,20 c11.046,0,20-8.954,20-20C394,314.918,407.918,301,425.026,301c17.108,0,31.025,13.918,31.025,31.025 c0,0.182,0.002,0.363,0.007,0.543c-0.206,12.247-7.563,23.211-18.864,28.035c-19.541,8.345-32.168,27.618-32.168,49.101V427 c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-17.296c0-5.438,3.092-10.271,7.875-12.313 c26.227-11.196,43.169-36.855,43.162-65.37C496.063,331.749,496.057,331.479,496.046,331.21z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.937,
    cy: 492,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.937,
    cy: 346,
    r: 20
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.a3fb4a48.svg";
export { ForwardRef as ReactComponent };